import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 7C3 5.94564 3.81588 5.08183 4.85074 5.00549L5 5H11.5858C12.0573 5 12.5116 5.16649 12.8702 5.46691L13 5.58579L16.415 9H27C28.0544 9 28.9182 9.81588 28.9945 10.8507L29 11V25.1111C29 26.1046 28.2329 26.919 27.2587 26.9943L27.1111 27H4.92015C3.91141 26.997 3.08526 26.2188 3.00619 25.2272L3 25.0769V7ZM27 11H5L4.999 25H27V11ZM11.5858 7H5V9H13.585L11.5858 7Z",
		fill: "black"
	})
});
export default SvgFolderOutlined;
